import { useTranslation } from 'react-i18next'

import Icon from '@/components/Icon'
import Price from '@/components/Price'

import useCheckout from '../../hooks/useCheckout'
import { CartButtonArrow, CartButtonContent, CartButtonLabel, CartButtonPrice, CartButtonWrapper } from './CartButton.styles'

interface CartButtonProps {
  onClick?: () => void
  disabled?: boolean
}

const CartButton = ({ onClick, disabled }: CartButtonProps) => {
  const { t } = useTranslation()
  const { cartTotal } = useCheckout()

  return (
    <CartButtonWrapper onClick={onClick} disabled={disabled}>
      <CartButtonContent>
        <Icon name="cart" />
        <CartButtonLabel>{t('cart')}:</CartButtonLabel>
        <CartButtonPrice>
          <Price>{cartTotal}</Price>
        </CartButtonPrice>
      </CartButtonContent>
      <CartButtonArrow />
    </CartButtonWrapper>
  )
}

export default CartButton
